import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, isFunction } from 'formik';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import * as actions from '../../features/plugin/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CreateFormForPlugin from '../../common/formElements/CreateFormForPlugin';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import ParentContentCard from '../common/ParentContentCard';
import CancelButton from '../../common/ui/CancelButton';
import SubmitButton from '../../common/ui/SubmitButton';
import DeleteButton from '../../common/ui/DeleteButton';
import PluginDescription from './PluginDescription';
import { showAlertHtml } from '../../common/utils/alert';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import PluginInstallTableHeader from './PluginInstallTableHeader';
import {
  checkToShowUpdateBtn,
  createSchemaForPluginConfiguration,
  prepareValidationForPluginConfiguration,
  showDeleteAlert,
} from './utils';
import ShowPluginDocs from './docs/ShowPluginDocs';
import { btn, btnOutline } from '../../common/ui/button-constants';
import { REST_API, pluginCode } from 'drapcode-constant';
import { snakeCaseToTitleCase } from '../../common/utils/api_utils';

export class UpdatePlugin extends Component {
  static propTypes = {
    plugin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { isConfigCorrect: false };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, pluginId, installedPluginId, version } = match.params;
    actions.loadPluginFields({ uuid: pluginId, projectId, version });
    if (installedPluginId) {
      actions.loadInstalledPluginDetail({ installedPluginId, version, projectId });
    }
    actions.loadRoles({ projectId, version });
    actions.loadProjectDetail({ projectId, version });
    actions.loadAllInstalledPlugin({ projectId, version });
  }
  handleSubmit = (values, resetForm) => {
    const { match, actions, history } = this.props;
    const { projectId, pluginId, installedPluginId, version } = match.params;
    if (installedPluginId) {
      const formData = {
        installedPluginId: installedPluginId,
        keystore: JSON.stringify(values),
        projectId: projectId,
        version,
      };
      actions.updateInstalledPlugin(formData).then(() => {
        resetForm();
        history.push(`/2.0/plugin/${version}/v/${projectId}`);
      });
    } else {
      const formData = {
        pluginUuid: pluginId,
        keystore: JSON.stringify(values),
        isEnabled: true,
        projectId: projectId,
        version,
      };
      actions.installPlugin(formData).then((res) => {
        resetForm();
        history.push(`/2.0/plugin/${version}/v/${projectId}`);
      });
    }
  };

  showSubmitButton = (handleSubmit, initialValues, values) => {
    const { plugin, match } = this.props;
    const { installedPluginId } = match.params;
    const { isConfigCorrect } = this.state;
    const { pluginField, updateInstalledPluginPending, installedPlugins } = plugin;
    const { code } = pluginField;
    const title = code === REST_API ? 'Rest API' : snakeCaseToTitleCase(code);
    const isTenantPlugin = installedPlugins.find(
      (plugin) => plugin.code === pluginCode.MULTI_TENANT_SAAS,
    );
    const userSettingsCollection = isTenantPlugin
      ? isTenantPlugin.setting.userSettingsCollection
      : null;
    const showUpdateBtn = checkToShowUpdateBtn(code, userSettingsCollection);
    if (showUpdateBtn) {
      return (
        <button
          type="button"
          className={btn.theme.medium}
          title={`Update ${title}`}
          onClick={() => handleSubmit()}
        >
          <i className={`wb ${drapcodeIcon('update')}`}></i>
          &nbsp;Update Plugin&nbsp;
          <CustomLoader loading={updateInstalledPluginPending} />
        </button>
      );
    }
  };
  handleCancel = () => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push(`/2.0/plugin/${version}/v/${projectId}`);
  };
  handleDelete = () => {
    const { projectId, installedPluginId, version } = this.props.match.params;
    const {
      plugin: { installedPlugins },
    } = this.props;
    const selectedPlugin =
      installedPlugins && installedPlugins.find((plugin) => plugin.uuid === installedPluginId);
    const { code } = selectedPlugin || '';

    const alertMsg = showDeleteAlert(code);
    const preConfirm = () => {
      this.props.actions
        .deleteInstalledPlugin({ projectId, installedPluginId, version })
        .then(() => {
          this.props.history.push(`/2.0/plugin/${version}/v/${projectId}`);
        });
    };
    showAlertHtml(alertMsg, preConfirm, 'Yes, delete it!');
  };

  showFormForFields = (setFieldValue, setFieldTouched, values) => {
    const {
      match,
      plugin,
      common,
      home: { events, pages, collections },
    } = this.props;
    const { installedPluginId } = match.params;
    const { projectDetail } = common;
    const { pluginField, roles, pluginDetail, installedPlugins } = plugin;
    const { fields, code } = pluginField;
    const isTenantPlugin = installedPlugins.find(
      (plugin) => plugin.code === pluginCode.MULTI_TENANT_SAAS,
    );
    let tenantCollection = null;
    if (isTenantPlugin) {
      //Load Tenant Collection
      tenantCollection = collections.find((collection) => collection.isTenantCollection === true);
    }
    return (
      <tbody>
        {Object.keys(fields).map((key, index) => (
          <CreateFormForPlugin
            key={key}
            name={key}
            field={fields[key]}
            code={code}
            events={events}
            pages={pages}
            roles={roles}
            collections={collections}
            projectDetail={projectDetail}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            isTenantPlugin={isTenantPlugin}
            tenantCollection={tenantCollection}
            pluginData={createSchemaForPluginConfiguration(fields, installedPluginId, pluginDetail)}
            values={values}
            update={true}
            installedPlugins={installedPlugins}
            actions={actions}
            match={match}
          />
        ))}
      </tbody>
    );
  };

  showUpdateCard = () => {
    const { home, plugin, common, match } = this.props;
    const { installedPluginId, projectId, version } = match.params;
    const { events, pages, collections } = home;
    const { projectDetail } = common;
    const { pluginDetail, updateInstalledPluginPending, pluginField, roles } = plugin;
    const { name, fields, code, description } = pluginField;
    const initialValues = createSchemaForPluginConfiguration(
      fields,
      installedPluginId,
      pluginDetail,
    );
    if (name && (pluginDetail || pluginDetail === '')) {
      return (
        <>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <PluginDescription
              code={code}
              description={description}
              projectDetail={projectDetail}
            />
          </div>
          <hr className={code === 'AWS_S3' ? 'mb-2' : 'mb-5'} />
          <Formik
            initialValues={initialValues}
            validationSchema={prepareValidationForPluginConfiguration(fields)}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              this.handleSubmit(values, resetForm);
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, values, setFieldValue, setFieldTouched }) => (
              <Form className="form-horizontal">
                <table className="table table-sm table-hover">
                  <PluginInstallTableHeader />
                  {fields && !_.isEmpty(fields)
                    ? this.showFormForFields(setFieldValue, setFieldTouched, values)
                    : ''}
                </table>
                <div className="row">
                  <div className="col-md-6  ">
                    <CancelButton
                      text="Cancel"
                      title="Cancel and go back to plugins"
                      onClick={this.handleCancel}
                    />
                  </div>
                  <div className="col-md-6 text-right">
                    &nbsp;
                    <DeleteButton
                      text="Uninstall"
                      title={`Uninstall ${name}`}
                      onClick={this.handleDelete}
                    />
                    &nbsp;
                    {this.showSubmitButton(handleSubmit, initialValues, values)}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </>
      );
    }
  };
  render() {
    const { installedPluginId } = this.props.match.params;
    const { plugin } = this.props;
    const { pluginField } = plugin;
    const { code, name } = pluginField;
    const title = (
      <>
        {name}
        {code === pluginCode.LOGIN ? <small> - User Collection Fields</small> : ''}
      </>
    );
    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <ParentContentCard icon="plugins" title={title}>
            {this.showUpdateCard()}
          </ParentContentCard>
          <ParentDocCard>
            <ShowPluginDocs code={code} />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    plugin: state.plugin,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePlugin);
